import React from "react"
import ScrollableAnchor from "react-scrollable-anchor"
import axios from "axios"
// @material-ui/core components
import Typography from "@material-ui/core/Typography/Typography"
import { createMuiTheme, MuiThemeProvider, withStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField/TextField"
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText"
// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx"
import GridItem from "../../../components/Grid/GridItem.jsx"
import Button from "../../../components/CustomButtons/Button.jsx"

import workStyle from "../../../assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx"
import foodImg from "../../../assets/img/vfood.jpg"
import PlacesSearchAutocomplete from "../../../components/MUIPlacesAutocomplete/PlacesSearchAutocomplete"
import TermsScrollDialog from "../../../components/ScrollDialog/TermsScrollDialog"
import PrivacyScrollDialog from "../../../components/ScrollDialog/PrivacyScrollDialog"
import { PhoneInputMask } from "./components/PhoneNumberInput"

const formTheme = createMuiTheme({
    typography: {
        fontFamily: [
            '"Open Sans"',
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
    },
    palette: {
        primary: {
            light: "#ffd343",
            main: "#FFC915",
            dark: "#b28c0e",
            contrastText: "#fff",
        },
    },
    overrides: {
        MuiOutlinedInput: {
            input: {
                padding: "14px",
                color: "rgb(60, 72, 88)",
                fontWeight: "500",
                borderRadius: "8px",
            },
            root: {
                "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
                    border: "1px solid rgba(0, 0, 0, 0.23)!important",
                },
            },
        },
        MuiInputLabel: {
            outlined: { transform: "translate(14px, 16px) scale(1)" },
        },
        MuiNotchedOutline: {
            root: {
                borderRadius: "8px",
            },
        },
    },
})

const formFields = {
    name: "name",
    email: "email",
    phone: "phone",
    restaurantName: "restaurantName",
    restaurantAddress: "restaurantAddress",
}

let formErrors = []

class ContactFormSection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showResult: false,
            processing: false,
            status: "success",
            fieldValues: {},
            focusedFields: [],
            termsOpened: false,
            privacyOpened: false,
        }
    }

    setFieldError = (fieldName, errorMessge, errorsArray) => {
        return [
            ...errorsArray.filter(e => e.fieldName !== fieldName),
            {
                fieldName: fieldName,
                message: errorMessge,
                active: true,
            },
        ]
    }

    removeFieldError = (fieldName, errorsArray) => [...errorsArray.filter(f => f.fieldName !== fieldName)]

    getFieldError = fieldName => formErrors.length > 0 && formErrors.find(e => e.fieldName === fieldName)

    showFieldError = fieldName => {
        const error = this.getFieldError(fieldName)
        return Boolean(error && error.active && !this.isFieldFocused(fieldName))
    }

    getFieldErrorMessage = fieldName => {
        const error = this.getFieldError(fieldName)
        return (error && error.active && error.message) || null
    }

    getFieldValue = fieldName => this.state.fieldValues[fieldName] || ""

    isFieldFocused = fieldName => this.state.focusedFields.includes(fieldName)

    handleInputChange = event => {
        const value = event.target.value
        const name = event.target.name

        this.setState({
            fieldValues: { ...this.state.fieldValues, [name]: value },
        })
    }

    handleInputOnBlur = event => {
        const value = event.target.value
        const name = event.target.name

        if (name === formFields.name && !value) {
            formErrors = this.setFieldError(formFields.name, "Please enter your Full Name", formErrors)
        } else if (name === formFields.name) {
            formErrors = this.removeFieldError(formFields.name, formErrors)
        }

        if (name === formFields.email && !value) {
            formErrors = this.setFieldError(formFields.email, "Email cannot be empty", formErrors)
        } else if (name === formFields.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
            formErrors = this.setFieldError(formFields.email, "Invalid email address", formErrors)
        } else if (name === formFields.email) {
            formErrors = this.removeFieldError(formFields.email, formErrors)
        }

        if (name === formFields.phone && !value) {
            formErrors = this.setFieldError(formFields.phone, "Phone number cannot be empty", formErrors)
        } else if (name === formFields.phone) {
            formErrors = this.removeFieldError(formFields.phone, formErrors)
        }

        if (name === formFields.restaurantName && !value) {
            formErrors = this.setFieldError(formFields.restaurantName, "Restaurant Name cannot be empty", formErrors)
        } else if (name === formFields.restaurantName) {
            formErrors = this.removeFieldError(formFields.restaurantName, formErrors)
        }

        if (name === formFields.restaurantAddress && !value) {
            formErrors = this.setFieldError(
                formFields.restaurantAddress,
                "Restaurant Address cannot be empty",
                formErrors
            )
        } else if (name === formFields.restaurantAddress) {
            formErrors = this.removeFieldError(formFields.restaurantAddress, formErrors)
        }

        this.setState(
            {
                focusedFields: [...this.state.focusedFields.filter(f => f !== name)],
            },
            () => {
                if (formErrors.length > 0) {
                    this.forceUpdate()
                }
            }
        )
    }

    handleInputOnFocus = event => {
        const name = event.target.name

        this.setState({
            focusedFields: [...this.state.focusedFields.filter(f => f !== name), name],
        })
    }

    triggerFieldsOnBlur = () => {
        Object.keys(formFields).forEach(key => {
            const fieldName = formFields[key]
            const dom = document.getElementById(fieldName)
            if (dom) {
                dom.focus()
                dom.blur()
            }
        })
    }

    onFormSubmit = e => {
        e.preventDefault()

        this.triggerFieldsOnBlur()

        if (formErrors && formErrors.length > 0) {
            return
        }

        this.setState(
            {
                processing: true,
            },
            () => {
                axios
                    .request({
                        url: "https://www.makeitbutter.com/api/graphql",
                        method: "POST",
                        data: {
                            query: `
                                mutation productSiteSignUpForm($input: ProductSiteSignUpFormPayload!) {
                                    productSiteSignUpForm(input: $input) {
                                        error
                                    }
                                }
                            `,
                            operationName: "productSiteSignUpForm",
                            variables: {
                                input: {
                                    name: this.state.fieldValues.name || "",
                                    emailAddress: this.state.fieldValues.email || "",
                                    phoneNumber: this.state.fieldValues.phone || "",
                                    companyName: this.state.fieldValues.restaurantName || "",
                                    companyAddress: this.state.fieldValues.restaurantAddress || "",
                                },
                            },
                        },
                    })
                    .then(response => {
                        this.setState({
                            showResult: true,
                            processing: false,
                            fieldValues: {},
                        })

                        setTimeout(() => {
                            this.setState({
                                showResult: false,
                            })
                        }, 5000)
                    })
                    .catch(error => {
                        this.setState({
                            showResult: true,
                            processing: false,
                            status: "error",
                            fieldValues: {},
                        })

                        setTimeout(() => {
                            this.setState({
                                showResult: false,
                            })
                        }, 5000)
                    })
            }
        )
    }

    handlePopoverOpen = (e, type) => {
        e.preventDefault()
        this.setState({
            [type]: true,
        })
    }

    handlePopoverClosed = (e, type) => {
        e.preventDefault()
        this.setState({
            [type]: false,
        })
    }

    render() {
        const { classes } = this.props

        return (
            <div>
                <TermsScrollDialog
                    open={this.state.termsOpened}
                    handleClose={e => this.handlePopoverClosed(e, "termsOpened")}
                />
                <PrivacyScrollDialog
                    open={this.state.privacyOpened}
                    handleClose={e => this.handlePopoverClosed(e, "privacyOpened")}
                />
                    <div className={classes.section}>
                        <GridContainer>
                            <GridItem xs={0} sm={0} md={0} lg={1} />
                            <GridItem xs={0} sm={0} md={6} lg={5} style={{
                                display: "flex",
                                textAlign: "center",
                                alignItems: "center",
                                justifyContent: "center",
                            }}>
                                <div>
                                    <img
                                        src={foodImg}
                                        alt="..."
                                        className={classes.productImage}
                                        style={{
                                            borderRadius: "6px",
                                            maxHeight: "45rem",
                                            maxWidth: "100%",
                                        }}
                                    />
                                </div>
                            </GridItem>
                            <ScrollableAnchor id="contactForm">
                            <GridItem xs={12} sm={12} md={6} lg={5}>
                                <GridContainer justify="center">
                                    <GridItem xs={11} sm={11} lg={12}>
                                        <h2 className={classes.title}>
                                            Take your restaurant to the <br /> next level today!
                                        </h2>
                                        <h4 className={classes.description}>
                                            When you join Make It Butter, we stand with you. <br />
                                            We’ll walk alongside you and set you up for success
                                        </h4>
                                    </GridItem>
                                </GridContainer>
                                <form id="contact-me-form" onSubmit={this.onFormSubmit}>
                                    <MuiThemeProvider theme={formTheme}>
                                        <GridContainer justify="center">
                                            <GridItem xs={11} sm={11} lg={9}>
                                                <TextField
                                                    style={{
                                                        width: "100%",
                                                        marginBottom: "1rem",
                                                    }}
                                                    label="Full Name"
                                                    variant="outlined"
                                                    id={formFields.name}
                                                    name={formFields.name}
                                                    value={this.getFieldValue(formFields.name)}
                                                    onChange={this.handleInputChange}
                                                    onBlur={this.handleInputOnBlur}
                                                    onFocus={this.handleInputOnFocus}
                                                />
                                                {this.showFieldError(formFields.name) && (
                                                    <FormHelperText className={classes.errorMessage}>
                                                        {this.getFieldErrorMessage(formFields.name)}
                                                    </FormHelperText>
                                                )}
                                            </GridItem>
                                            <GridItem xs={11} sm={11} lg={9}>
                                                <TextField
                                                    style={{
                                                        width: "100%",
                                                        marginBottom: "1rem",
                                                    }}
                                                    label="Email"
                                                    variant="outlined"
                                                    id={formFields.email}
                                                    name={formFields.email}
                                                    value={this.getFieldValue(formFields.email)}
                                                    onChange={this.handleInputChange}
                                                    onBlur={this.handleInputOnBlur}
                                                    onFocus={this.handleInputOnFocus}
                                                />
                                                {this.showFieldError(formFields.email) && (
                                                    <FormHelperText className={classes.errorMessage}>
                                                        {this.getFieldErrorMessage(formFields.email)}
                                                    </FormHelperText>
                                                )}
                                            </GridItem>
                                            <GridItem xs={11} sm={11} lg={9}>
                                                <TextField
                                                    style={{
                                                        width: "100%",
                                                        marginBottom: "1rem",
                                                    }}
                                                    label="Phone"
                                                    variant="outlined"
                                                    id={formFields.phone}
                                                    name={formFields.phone}
                                                    value={this.getFieldValue(formFields.phone)}
                                                    onChange={this.handleInputChange}
                                                    onBlur={this.handleInputOnBlur}
                                                    onFocus={this.handleInputOnFocus}
                                                    InputProps={{
                                                        inputComponent: PhoneInputMask,
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: !!this.getFieldValue(formFields.phone),
                                                    }}
                                                />

                                                {this.showFieldError(formFields.phone) && (
                                                    <FormHelperText className={classes.errorMessage}>
                                                        {this.getFieldErrorMessage(formFields.phone)}
                                                    </FormHelperText>
                                                )}
                                            </GridItem>
                                            <GridItem xs={11} sm={11} lg={9}>
                                                <TextField
                                                    style={{
                                                        width: "100%",
                                                        marginBottom: "1rem",
                                                    }}
                                                    label="Restaurant Name"
                                                    variant="outlined"
                                                    id={formFields.restaurantName}
                                                    name={formFields.restaurantName}
                                                    value={this.getFieldValue(formFields.restaurantName)}
                                                    onChange={this.handleInputChange}
                                                    onBlur={this.handleInputOnBlur}
                                                    onFocus={this.handleInputOnFocus}
                                                />
                                                {this.showFieldError(formFields.restaurantName) && (
                                                    <FormHelperText className={classes.errorMessage}>
                                                        {this.getFieldErrorMessage(formFields.restaurantName)}
                                                    </FormHelperText>
                                                )}
                                            </GridItem>
                                            <GridItem xs={11} sm={11} lg={9}>
                                                <PlacesSearchAutocomplete
                                                    textFieldProps={{
                                                        style: {
                                                            width: "100%",
                                                            marginBottom: "1rem",
                                                        },
                                                        label: "Restaurant Address",
                                                        variant: "outlined",
                                                        id: formFields.restaurantAddress,
                                                        name: formFields.restaurantAddress,
                                                        value: this.getFieldValue(formFields.restaurantAddress),
                                                        onChange: this.handleInputChange,
                                                        onBlur: this.handleInputOnBlur,
                                                        onFocus: this.handleInputOnFocus,
                                                    }}
                                                    onChangeCallback={address => {
                                                        const fullAddress =
                                                            (address.addressLine1 || "") +
                                                            (address.addressLine2 || "") +
                                                            ", " +
                                                            (address.city || "") +
                                                            ", " +
                                                            (address.state || "") +
                                                            ", " +
                                                            (address.zip || "")
                                                        this.setState({
                                                            fieldValues: {
                                                                ...this.state.fieldValues,
                                                                [formFields.restaurantAddress]: fullAddress,
                                                            },
                                                        })
                                                    }}
                                                    showUseMyPositionOption={false}
                                                />
                                                {this.showFieldError(formFields.restaurantAddress) && (
                                                    <FormHelperText className={classes.errorMessage}>
                                                        {this.getFieldErrorMessage(formFields.restaurantAddress)}
                                                    </FormHelperText>
                                                )}
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer
                                            justify="center"
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                            }}>
                                            {this.state.showResult ? (
                                                <GridItem xs={11} sm={11} lg={9} className={classes.textCenter}>
                                                    <Button
                                                        size="lg"
                                                        style={{
                                                            width: "100%",
                                                            backgroundColor:
                                                                this.state.status === "success" ? "#5ACA75" : "#f44336",
                                                            color: "white",
                                                            fontFamily: "Open Sans",
                                                            fontSize:
                                                                this.state.status === "success" ? "1rem" : "0.9rem",
                                                        }}
                                                        color="primary">
                                                        {this.state.status === "success" ? (
                                                            "Successfully sent. Thank you!"
                                                        ) : (
                                                            <span>
                                                                Oops, something wrong happened.
                                                                <br />
                                                                Please try again later.
                                                            </span>
                                                        )}
                                                    </Button>
                                                </GridItem>
                                            ) : (
                                                <GridItem xs={11} sm={11} lg={9} className={classes.textCenter}>
                                                    <Button
                                                        size="lg"
                                                        style={{
                                                            width: "100%",
                                                            fontFamily: "Open Sans",
                                                            fontSize: "1rem",
                                                        }}
                                                        type="submit"
                                                        color="primary">
                                                        {!this.state.processing && <span>Sign Up!</span>}
                                                        {this.state.processing && <span>Sending...</span>}
                                                    </Button>
                                                </GridItem>
                                            )}
                                            <GridItem
                                                xs={11}
                                                sm={11}
                                                lg={9}
                                                className={classes.textCenter}
                                                style={{ padding: 0 }}>
                                                <Typography
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        marginTop: "1rem",
                                                        opacity: 0.75,
                                                    }}>
                                                    By signing up, you agree to the{" "}
                                                    <a
                                                        href="#terms"
                                                        onClick={e => this.handlePopoverOpen(e, "termsOpened")}
                                                        style={{ color: "#4a90e2", textDecoration: "underline" }}
                                                        target="_blank">
                                                        Terms of Service
                                                    </a>{" "}
                                                    &{" "}
                                                    <a
                                                        href="#privacy"
                                                        onClick={e => this.handlePopoverOpen(e, "privacyOpened")}
                                                        style={{ color: "#4a90e2", textDecoration: "underline" }}
                                                        target="_blank">
                                                        Privacy Policy
                                                    </a>
                                                </Typography>
                                            </GridItem>
                                        </GridContainer>
                                    </MuiThemeProvider>
                                </form>
                            </GridItem>
                            </ScrollableAnchor>
                        </GridContainer>
                    </div>
            </div>
        )
    }
}

export default withStyles(workStyle)(ContactFormSection)



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/ContactFormSection.jsx